import { useState } from "react";

import HexSearchBox from "../../../../components/HexSearchBox";
import HexFilters from "../../../../components/HexFilters";

import "./style.css";

const FilterSearchBox = ({
  onSaveFilter,
  filterValues,
  FilterComponent,
  dropdownPlacement,
}) => {
  const [search, setSearch] = useState(filterValues.search || "");

  const onSearchChange = (text) => {
    !text.trim() && search && onSaveFilter({ ...filterValues, search: "" });
    setSearch(text);
  };

  const onSearchSubmit = () => {
    onSaveFilter({ ...filterValues, search });
  };

  const onApplyFilter = (filter) => {
    const appliedFilter = {
      ...filterValues,
      menuFilter: { ...filter },
    };

    onSaveFilter(appliedFilter);
  };

  return (
    <div className="filter-box-container">
    
      <HexSearchBox
        value={search}
        onChange={onSearchChange}
        onSubmit={onSearchSubmit}
        className={"full-width"}
      />

      <HexFilters
        dropdownClass={"filter-dropdown"}
        Filters={({ onSave }) => (
          <FilterComponent
            onSave={onSave}
            filterParams={filterValues.menuFilter}
          />
        )}
        componentProps={{
          onSave: onApplyFilter,
        }}
        dropdownPlacement={dropdownPlacement || "bottom"}
      />
    </div>
  );
};

export default FilterSearchBox;
